const files = import.meta.glob("./screenshots/*.png", { eager: true, import: "default" }) as Record<string, string>;

export function helpImage(key: string | undefined): string | undefined {
  if (!key) return undefined;
  return files[`./screenshots/${key}.png`];
}
